import React from 'react'
import { TouchableOpacity, View, Text } from 'react-native';
import Styles from './Styles.js'

class RadioButton extends React.Component {
  constructor(props) {
    super(props);
  }

  buttonClicked() {
    this.props.buttonClicked(this.props.id)
    this.props.onPress(this.props.id)
  }

  render() {
    return (
      <TouchableOpacity onPress={() => this.buttonClicked()}>
        <View style={this.props.selected ? Styles.buttonSelected : Styles.buttonUnselected}>
          <Text style={Styles.buttonText}>
            {this.props.title}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }
}

export default RadioButton
